<template>
  <UButton
    icon="fa7-solid:magnifying-glass"
    variant="ghost"
    size="xl"
    @click="dialogOpen = !dialogOpen"
  />

  <ClientOnly>
    <!-- 搜索弹窗 -->
    <LazyUContentSearch
      v-model:search-term="searchTerm"
      :search="dbSearch"
      :navigation="articleList"
      :search-status="dbStatus"
      shortcut="meta_k"
      :color-mode="false"
      portal
      transition
      overlay
      :fullscreen="isMdWidth"
      :fuse="{ resultLimit: 42 }"
      :ui="{
        // 弹窗大容器
        content: 'rounded-none',
      }"
    >
      <!-- 右上角关闭按钮 -->
      <template #close>
        <UButton
          icon="material-symbols:close"
          variant="ghost"
          size="xl"
          @click="dialogOpen = false"
        />
      </template>
      <template #empty>
        <!-- 未找到内容时 -->
        <div :class="'flex items-center justify-center h-20'">
          <h4 :class="['lg:text-lg text-md']">{{ t('placeholder.notFound') }}</h4>
        </div>
      </template>
    </LazyUContentSearch>
  </ClientOnly>
</template>

<script setup lang="ts">
  const { t } = useI18n()
  const { isMdWidth } = useClientWidth()

  // 获取所有文章元数据
  const { searchDbArticle, getArticleList } = useI18nContent()
  const { open: dialogOpen } = useContentSearch()
  const { search: dbSearch, status: dbStatus, init: dbInit } = searchDbArticle()
  const {
    // 关键词为空时候展示用的导航树
    data: articleList,
  } = await getArticleList()

  /** 搜索关键词 */
  const searchTerm = ref('')

  watch(dialogOpen, value => {
    if (value && dbStatus.value === 'idle') {
      dbInit()
    }
  })
</script>
